<template>
    <datepicker :value="data" :language="ru" @selected="change" :format="customFormatter"></datepicker>
</template>

<script>
    import datepicker from 'vuejs-datepicker';
    import {ru} from 'vuejs-datepicker/dist/locale'

    export default {
        props: ['value'],
        components: {
            datepicker
        },
        data () {
            return {
                data: null,
                ru: ru
            }
        },
        methods: {
            change (e) {
                let data = this.moment(e).format('YYYY-MM-DD 00:00')
                this.data = data
                this.$emit('update:value', data)
                this.$emit('dateUpdate', data)
            },
            customFormatter(date) {
                return this.moment(date).format('YYYY-MM-DD HH:mm');
            }
        },
        watch: {
            value() {
                this.data = this.value
            }
        },
        created () {
            if (this.value) this.data = this.value
        }
    }
</script>